// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"82":"51fb1dee","555":"32128fbf"}[chunkId] + ".css";
};